module.exports = __webpack_public_path__ + "./fonts/opera.9f26d792b01c0809c8a5b68823699aa6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/opera.svg
// module id = ./assets/images/opera.svg
// module chunks = 0